import AnchorLink from '@helsenorge/designsystem-react/components/AnchorLink';
import List from '@helsenorge/designsystem-react/components/List';
import Title from '@helsenorge/designsystem-react/components/Title';
export const DEFAULT_MARKDOWN_OVERRIDES = {
    h1: {
        component: Title,
        props: {
            htmlMarkup: 'h1',
            appearance: 'title1',
        },
    },
    h2: {
        component: Title,
        props: {
            htmlMarkup: 'h2',
            appearance: 'title2',
        },
    },
    h3: {
        component: Title,
        props: {
            htmlMarkup: 'h3',
            appearance: 'title3',
        },
    },
    h4: {
        component: Title,
        props: {
            htmlMarkup: 'h4',
            appearance: 'title4',
        },
    },
    h5: {
        component: Title,
        props: {
            htmlMarkup: 'h5',
            appearance: 'title5',
        },
    },
    a: {
        component: AnchorLink,
    },
    ul: {
        component: List,
        props: {
            variant: 'bullet',
        },
    },
    ol: {
        component: List,
        props: {
            variant: 'numbered',
        },
    },
    li: {
        component: List.Item,
    },
};
